import { PropType, defineComponent } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { SvgAttribute } from "@/shared/constants/constants";
import { SearchType, SearchStatus } from "@/shared/constants/enums";
import {
  AdminUsersFilterOption,
  AdminUsersFilterOptions,
  AdminUsersStatusOptions,
} from "@/data/admin/users/filter";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    value: {
      type: String,
      default: "",
    },
    type: {
      type: <PropType<SearchType>>String,
      default: SearchType.all,
    },
    status: {
      type: <PropType<SearchStatus>>String,
      default: SearchStatus.all,
    },
  },
  emits: {
    "update:value": null,
    "update:type": null,
    "update:status": null,
  },
  data() {
    return {
      isToggle: false,
      isToggleStatus: false,
    };
  },
  computed: {
    displayedOptions(): AdminUsersFilterOption[] {
      return AdminUsersFilterOptions(this.type);
    },

    displayedStatusOptions(): AdminUsersFilterOption[] {
      return AdminUsersStatusOptions(this.status);
    },

    displayedIcons(): SvgAttribute {
      return SVG;
    },

    isClearShow(): boolean {
      return !!this.value;
    },
  },
  methods: {
    handleToggle(): void {
      this.isToggle = !this.isToggle;
    },

    handleToggleStatus(): void {
      this.isToggleStatus = !this.isToggleStatus;
    },

    handleHide(): void {
      this.isToggle = false;
    },

    handleHideStatus(): void {
      this.isToggleStatus = false;
    },

    handleValue(event: Event): void {
      this.$emit("update:value", (<HTMLInputElement>event.target).value);
    },

    handleClear(): void {
      this.$emit("update:value", "");
    },

    handleOption(type: SearchType): void {
      this.$emit("update:type", type);
    },

    handleStatusOption(status: SearchStatus): void {
      this.$emit("update:status", status);
    },
  },
});
